<template>
  <div class="Menu">
    <a-menu mode="inline" :open-keys.sync="openKeys">
      <a-sub-menu v-for="(item, index) in munelist" :key="index + 1">
        <span slot="title" class="del"
          ><img src="../../assets/course/del.png" alt="" />
          <span class="delspan">{{ item.title }}</span>
        </span>
        <a-menu-item
          :title="v.title"
          v-for="v in item.tasks"
          :key="v.id"
          @click="
            () => {
              $emit(
                'todetail',
                catalogId,
                v.id,
                v.isFree,
                v.type,
                v.title,
                v.paperId,
                v.isFinished,
                isLogin,
                item.id
              );
              $emit(
                'getdetail',
                catalogId,
                v.id,
                v.type,
                v.title,
                v.testInfo,
                v.paperId,
                v.isFinished,
                isLogin,
                v.isFree,
                item.id
              );
            }
          "
        >
          <template v-if="v.isFinished || taskId == v.id">
            <img class="inp" src="../../assets/course/finish.png" alt="" />
          </template>
          <template v-else>
            <img class="inp" src="../../assets/course/nofinish.png" alt="" />
          </template>
          <img v-if="v.type == 0" src="../../assets/course/video.png" alt="" />
          <img
            v-else-if="v.type == 1"
            src="../../assets/course/text.png"
            alt=""
          />
          <img
            v-else-if="v.type == 2"
            src="../../assets/course/play.png"
            alt=""
          />
          <img v-else src="../../assets/course/play.png" alt="" />
          <span v-if="v.type == 0">【视频】</span>
          <span v-else-if="v.type == 1">【资料】</span>
          <span v-else-if="v.type == 2">【测试】</span>
          <span v-else>【考试】</span>
          {{ v.title }}
          <span class="try" v-if="v.isFree == 1">试看</span>
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    munelist: Array,
    catalogId: [String, Number],
    testId: [String, Number],
    examAccess: Boolean,
  },
  created() {},
  data() {
    return {
      openKeys: [],
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    taskId() {
      return this.$store.state.taskId;
    },
  },
};
</script>
<style lang="stylus">
.ant-menu-sub.ant-menu-inline > .ant-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Menu .del {
  color: #333;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.Menu .del .delspan {
  width: 100%;
  overflow: hidden;
  margin-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #4281ff;
  color: #fff;
}
</style>
<style lang="stylus" scoped>
.Menu {
  .del {
    color: #333333;
    display: flex;
    align-items: center;

    img {
      width: 18px;
      height: 15px;
      margin-right: 17px;
    }
  }

  .inp {
    margin-right: 10px;
  }

  .try {
    width: 44px;
    height: 22px;
    background-color: #e3f8ff;
    border: solid 1px #f0cd48;
    font-size: 12px;
    color: #f0cd48;
    position: absolute;
    right: 20px;
    text-align: center;
    line-height: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 666;
    cursor: pointer;
  }
}
</style>